import { enableProdMode } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { CreatePartnerComponent } from '@app/create-partner/create-partner.component';
import { environment } from '@environments/environment';
import { init } from "@sentry/angular";
import { SentryConfig } from '@src/sentry.config';

if (environment.production) {
  enableProdMode();
  init(SentryConfig);
}

(async () => {
  const app = await createApplication(appConfig);

  const inputElement = createCustomElement(CreatePartnerComponent, {
    injector: app.injector,
  });
  customElements.define(environment.customElementTag, inputElement);
})();